import { createFileRoute } from "@tanstack/react-router";
import { BrandPage } from "@/components/brand/BrandPage";
import { brandSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/brand")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => brandSeo(loaderData?.href ?? "/brand"),
  component: BrandPage,
});
